import { render, staticRenderFns } from "./DomainScripts.vue?vue&type=template&id=6a4b0ade&"
import script from "./DomainScripts.vue?vue&type=script&lang=js&"
export * from "./DomainScripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports